// extracted by mini-css-extract-plugin
export default {"notFound":"NotFoundPage_notFound__gTfDQ","description":"NotFoundPage_description__Wkftx"};